const { gql } = require('@apollo/client');

export const QUERY_CMS_PROPERTY_LANDLORD_CONTRACT = gql`
  query CMS_PROPERTY_LANDLORD_CONTRACT($slug: String) {
    property(slug: $slug) {
      id
      contracts {
        id
        signedDate
        effectiveFrom
        effectiveTo
      }
      landlord {
        id
        slug
        contracts {
          edges {
            node {
              id
              signedDate
              effectiveFrom
              effectiveTo
              files {
                id
                name
                source
                updatedAt
                contentType
                contractId
                createdAt
              }
            }
          }
        }
      }
    }
  }
`;
